import { SVGProps } from 'react'

interface WordmarkProps extends SVGProps<SVGSVGElement> {
  className?: string
}

export function Wordmark({ className = 'h-6 w-auto', ...props }: WordmarkProps) {
  return (
    <svg
      className={className}
      width="200"
      height="200"
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="200" height="200" fill="white" />
      <path
        d="M127.78 8.31151C125.97 2.85697 122.349 0 116.4 0H60.7914C53.5498 0 49.9287 4.41576 52.2561 11.4285L109.934 191.688C111.745 197.143 115.366 200 121.314 200H185.199C192.441 200 187.527 195.584 185.199 188.572L127.78 8.31151Z"
        fill="currentColor"
      />
      <path
        d="M57.5255 82.3238C54.6734 73.5685 47.4131 73.5685 44.5611 82.3238L11.6306 188.67C9.55677 195.622 12.6682 200 19.9279 200H83.4543C90.7146 200 94.3448 195.622 92.011 188.67L57.5255 82.3238Z"
        fill="currentColor"
      />
    </svg>
  )
}
